module.exports = __webpack_public_path__ + "img/timer_color_black.d0732af7.svg";